"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTab = exports.TabContext = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../utils/hooks");
exports.TabContext = react_1.default.createContext(null);
function useTab(label, children, current, onTabChange) {
    const [activeIndex, setActiveIndex] = (0, react_1.useState)(0);
    const prevCount = (0, hooks_1.usePrevious)(0, activeIndex);
    if (prevCount !== activeIndex) {
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(activeIndex);
    }
    const findNextValidTab = react_1.default.useCallback(() => {
        var _a;
        if (children[current] && !((_a = children[current]) === null || _a === void 0 ? void 0 : _a.props.disabled)) {
            return current;
        }
        if (!Array.isArray(children) || current > children.length) {
            return 0;
        }
        const validTab = children.find((button) => !button.props.disabled);
        return validTab ? children.indexOf(validTab) : 0;
    }, [current, children]);
    react_1.default.useMemo(() => {
        setActiveIndex(findNextValidTab());
    }, [current, children]);
    const getContext = (0, react_1.useCallback)((index) => {
        return {
            label,
            selected: activeIndex === index,
            onActivate: () => setActiveIndex(index),
        };
    }, [activeIndex]);
    const activeContent = react_1.default.useMemo(() => {
        var _a;
        return (_a = children[activeIndex]) === null || _a === void 0 ? void 0 : _a.props.children;
    }, [activeIndex]);
    const activeTitle = react_1.default.useMemo(() => {
        var _a;
        return (_a = children[activeIndex]) === null || _a === void 0 ? void 0 : _a.props.title;
    }, [activeIndex]);
    const tabButtons = react_1.default.Children.map(children, (child, index) => {
        return (react_1.default.createElement(exports.TabContext.Provider, { value: getContext(index) }, child));
    });
    return { tabButtons, activeContent, activeTitle };
}
exports.useTab = useTab;
//# sourceMappingURL=useTab.js.map